import Environment from '@/interfaces/environment.interface'
import onEnvironmentChange from '@observables/environment.observable'
import { AxiosResponse } from 'axios'
import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { take } from 'rxjs'
import LogService from '../log/log.service'
import MainService from '../main/main.service'

export default class ProxyAuthService extends MainService {
  app: any
  auth: any
  url: string
  googleUrl: string
  logService = new LogService()

  constructor(proxyAuthUrl?: string) {
    super()

    onEnvironmentChange.pipe(take(1)).subscribe((environment: Environment) => {
      this.app = initializeApp(environment?.firebase)
      this.auth = getAuth(this.app)
      this.googleUrl = environment?.exteralApis?.google
      if (!proxyAuthUrl) {
        this.url = environment?.squidApis?.proxy
      } else {
        this.url = proxyAuthUrl
      }
    })
    this.logService.init('WebProxyAuth Service')
  }

  public async googleLogin() {
    window.location.assign(`${this.url}/youtube?hub=true&squid-callback=${window?.location?.href}`)
  }

  public async getGoogleUser(accessToken: string) {
    const header = { Authorization: `Bearer ${accessToken}` }
    return this.http.get(`${this.googleUrl}/oauth2/v1/userinfo`, { headers: header }).then((r: AxiosResponse) => r.data)
  }
}
